// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1PIWN","rootSmall":"AddTileButton_rootSmall__3O4qQ"};